$(function() {
  // Cache frequently used selectors
  const $mobileMenuTitles = $('#mobile-menu .title');
  const $primaryMenu = $('.primary-menu');
  const $master = $('#master');
  
  // Mobile menu toggle
  $mobileMenuTitles.on('click', function(e) {
    const $this = $(this);
    $this.addClass('open_mobile');
    $this.next('ul').toggle();
  });

  // Replace 'x' with cross image - more efficient selector and escaping
  $("li.details").each(function() {
    const $this = $(this);
    if ($this.text().includes('x')) {
      $this.html($this.html().replace(/x/g, 
        "<img src='https://cdn.shopify.com/s/files/1/0070/6402/t/57/assets/cross.png?v=1652305897' alt='Close' />"
      ));
    }
  });

  // Desktop menu handlers - consolidated with event delegation
  $primaryMenu.on('click', '.menu-opener__text', function(e) {
    e.stopPropagation();
    
    const $this = $(this);
    const $parent = $this.closest('li');
    
    // Close all menus first
    $('.megamenu, .image-column').removeClass('open');
    
    // Open the clicked menu
    if ($parent.hasClass('mens-menu')) {
      $('.mens-megamenu, .image-column.mens-image').addClass('open');
    } else if ($parent.hasClass('womens-menu')) {
      $('.womens-megamenu, .image-column.womens-image').addClass('open');
    } else if ($parent.hasClass('objects-menu')) {
      $('.objects-megamenu, .image-column.objects-image').addClass('open');
    }
  });

  // Close menus when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.primary-menu, .megamenu').length) {
      $('.megamenu, .image-column').removeClass('open');
    }
  });

  // Brands accordion
  $master.on('click', '.brands-accordion', function() {
    const $this = $(this);
    $('#master .brands').removeClass('active');
    $this.toggleClass('active open_sub');
  });

  // Master menu items
  $master.on('click', 'li.master', function() {
    const $this = $(this);
    
    // Close other accordions
    $('.accordion').removeClass('active');
    $('.accordion').next('.panel').hide();
    
    // Toggle current item
    $this.toggleClass('open_sub');
    $this.next('ul.master-sub').toggleClass('visible');
  });

  // Prevent event bubbling for sub-menu links
  $master.on('click', 'li.master ul li a', function(e) {
    e.stopPropagation();
  });

  // Uncommented product details toggle (if needed)
  /*
  $('#detail-titles li').on('click', function() {
    const $this = $(this);
    const value = $this.data('value');
    const $content = $('#detail-content .' + value);
    
    $this.addClass('active').siblings().removeClass('active');
    $content.addClass('active').siblings().removeClass('active');
  });
  */
});